export function recordToArray<T>(obj: Record<string, T>): (T & { id: string })[] {
  return Object.keys(obj).map((key) => ({ ...obj[key], id: key }));
}
